const developmentEnvironments = ['test', 'accept']

export const isDevelopmentEnvironment = (environment?: 'dev' | 'ci' | 'test' | 'accept' | 'prod') => {
  if (!environment) {
    return false
  }
  return developmentEnvironments.includes(environment)
}
